// src/components/Navbar/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';
import { motion } from 'framer-motion'; // Импорт motion

// Варианты анимации для навбара
const navVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, ease: "easeOut", delay: 0.1 }
    },
};

// Варианты для контейнера ссылок (для каскадного появления)
const linkContainerVariants = {
    hidden: {}, // Не нужно, если сам навбар анимируется
    visible: {
        transition: {
            staggerChildren: 0.1, // Задержка между анимацией каждой ссылки
            delayChildren: 0.3,   // Общая задержка перед началом анимации ссылок (после появления навбара)
        },
    },
};

// Варианты для отдельных ссылок
const linkItemVariants = {
    hidden: { opacity: 0, y: -15 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3, ease: "easeOut" } },
};

const Navbar = () => {
    return (
        <motion.nav
            className={styles.navbar}
            variants={navVariants}
            initial="hidden"
            animate="visible"
        >
            <motion.div
                className={styles.navContainer}
                // variants={linkContainerVariants} // Применяем варианты к обертке ссылок, если нужно
                // initial="hidden"
                // animate="visible"
            >
                <Link to="/" className={styles.navLogo}>YEP</Link> {/* Лого можно тоже анимировать отдельно */}

                <motion.ul
                    className={styles.navMenu}
                    variants={linkContainerVariants} // Применяем варианты к ul для каскада li
                    initial="hidden"
                    animate="visible"
                >
                    <motion.li className={styles.navItem} variants={linkItemVariants}>
                        <Link to="/about" className={styles.navLink}>О проекте</Link>
                    </motion.li>
                    <motion.li className={styles.navItem} variants={linkItemVariants}>
                        <Link to="/status" className={styles.navLink}>Статус</Link>
                    </motion.li>
                    <motion.li className={styles.navItem} variants={linkItemVariants}>
                        <Link to="/team" className={styles.navLink}>
                            YEP<span className={styles.ampersandNav}>&</span>TEAM
                        </Link>
                    </motion.li>
                </motion.ul>
            </motion.div>
        </motion.nav>
    );
};

export default Navbar;